// extracted by mini-css-extract-plugin
export var checkboxContainer = "checkbox-module--checkbox-container--1it71";
export var checkbox = "checkbox-module--checkbox--2GHYX";
export var invalidUnchecked = "checkbox-module--invalid-unchecked--3JqBe";
export var invalidChecked = "checkbox-module--invalid-checked--2p37T";
export var errorMessage = "checkbox-module--error-message--AI_J_";
export var disabled = "checkbox-module--disabled--1jk72";
export var selectbox = "checkbox-module--selectbox--26OPO";